import { IState } from '../../store';
import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export const MORTGAGE_PROMO_DISCOUNT_CAMPAIGN_EXPERIMENT = 'mortgage_promo_discount_campaign';

export const selectMortgagePromoDiscountCampaignActive = (state: IState) => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, MORTGAGE_PROMO_DISCOUNT_CAMPAIGN_EXPERIMENT, 'B');
};
